export type Bi = { fr: string; en: string }

export type SectorKey = 'cities' | 'professional' | 'animal' | 'campus' | 'airports'

export type Sector = {
  key: SectorKey
  /** Section anchor on the /secteurs page */
  anchor: string
  name: Bi
  descriptor: Bi
  copy: Bi
  relations: Bi[]
  proven?: boolean
}

// Shared by the Secteurs mega-menu and the /secteurs page.
// Only Cities & Governments carries the production badge — do not add it elsewhere.
export const sectors: Sector[] = [
  {
    key: 'cities',
    anchor: 'villes',
    name: { fr: 'Villes et gouvernements', en: 'Cities & government' },
    descriptor: {
      fr: 'Citoyens · services · communications · transactions',
      en: 'Residents · services · communications · transactions',
    },
    copy: {
      fr: 'Connecter citoyens, identité, communications, transactions et services publics.',
      en: 'Connecting residents, identity, communications, transactions and public services.',
    },
    relations: [
      { fr: 'Citoyen', en: 'Resident' },
      { fr: 'Propriété', en: 'Property' },
      { fr: 'Famille', en: 'Family' },
      { fr: 'Permis', en: 'Permits' },
      { fr: 'Loisirs', en: 'Recreation' },
    ],
    proven: true,
  },
  {
    key: 'professional',
    anchor: 'entreprises',
    name: { fr: 'Entreprises et services professionnels', en: 'Business & professional services' },
    descriptor: {
      fr: 'Clients · équipes · partenaires · services',
      en: 'Clients · teams · partners · services',
    },
    copy: {
      fr: 'Relier clients, équipes, partenaires et services dans une même expérience de confiance.',
      en: 'Connecting clients, teams, partners and services in one trusted experience.',
    },
    relations: [
      { fr: 'Client', en: 'Client' },
      { fr: 'Équipe', en: 'Team' },
      { fr: 'Partenaire', en: 'Partner' },
    ],
  },
  {
    key: 'animal',
    anchor: 'sante-animale',
    name: { fr: 'Santé animale', en: 'Animal health' },
    descriptor: {
      fr: 'Propriétaires · animaux · cliniques · services',
      en: 'Owners · animals · clinics · services',
    },
    copy: {
      fr: 'Relier propriétaires, animaux, cliniques, rendez-vous, communications et services.',
      en: 'Connecting owners, animals, clinics, appointments, communications and services.',
    },
    relations: [
      { fr: 'Propriétaire', en: 'Owner' },
      { fr: 'Animal', en: 'Animal' },
      { fr: 'Clinique', en: 'Clinic' },
    ],
  },
  {
    key: 'campus',
    anchor: 'universites',
    name: { fr: 'Universités et campus', en: 'Universities & campuses' },
    descriptor: {
      fr: 'Étudiants · communautés · accès · services',
      en: 'Students · communities · access · services',
    },
    copy: {
      fr: 'Relier étudiants, communautés, accès, communications et services du campus.',
      en: 'Connecting students, communities, access, communications and campus services.',
    },
    relations: [
      { fr: 'Étudiant', en: 'Student' },
      { fr: 'Communauté', en: 'Community' },
      { fr: 'Accès', en: 'Access' },
    ],
  },
  {
    key: 'airports',
    anchor: 'aeroports',
    name: { fr: 'Aéroports et transport', en: 'Airports & transportation' },
    descriptor: {
      fr: 'Voyageurs · employés · partenaires · services',
      en: 'Travellers · employees · partners · services',
    },
    copy: {
      fr: 'Relier voyageurs, employés, partenaires, accès, communications et services.',
      en: 'Connecting travellers, employees, partners, access, communications and services.',
    },
    relations: [
      { fr: 'Voyageur', en: 'Traveller' },
      { fr: 'Employé', en: 'Employee' },
      { fr: 'Partenaire', en: 'Partner' },
    ],
  },
]

export const sectorsMenuCopy = {
  eyebrow: { fr: 'Secteurs', en: 'Sectors' },
  headline: [
    { fr: 'Des écosystèmes différents.', en: 'Different ecosystems.' },
    { fr: 'Un même défi : tout relier.', en: 'The same connection challenge.' },
  ],
  signature: [
    { fr: 'Une identité.', en: 'One identity.' },
    { fr: 'Plusieurs relations.', en: 'Many relationships.' },
    { fr: 'Une multitude de services.', en: 'A multitude of services.' },
  ],
  link: { fr: 'Découvrir nos secteurs', en: 'Explore our sectors' },
  badge: { fr: 'Éprouvé en production', en: 'Proven in production' },
}
